module.exports = __webpack_public_path__ + "static/media/TWI CAROUSEL 03.ee4505a7.jpg";